export const EXTERNAL_LINKS = {
	QUICKSTART_VIDEO: 'https://www.youtube.com/watch?v=4cQWJViybAQ',
	DOCUMENTATION: 'https://docs.n8n.io?utm_source=n8n_app&utm_medium=app_sidebar',
	FORUM: 'https://community.n8n.io?utm_source=n8n_app&utm_medium=app_sidebar',
	COURSES: 'https://docs.n8n.io/courses/',
} as const;
